'use strict';

module Patersons {

    export class PortfolioNavigationComponent implements ng.IComponentOptions {
        templateUrl: string = 'assets/templates/portfolioSummary/components/portfolioNavigation.component.html';
        controller: any = PortfolioNavigationController;
        bindings: any = {
            key: '@'
        };
    }
    export interface PortfolioNavigationScope extends ng.IScope {
        events: Patersons.PortfolioNavigationController;
        items: any;
        menuOpen: boolean
        userCompany: UserCompany;
      }

    export class PortfolioNavigationController {
        private $ctrl: any;
        scope: Patersons.PortfolioNavigationScope;
        state: angular.ui.IStateService;
        location: angular.ILocationService;
        stateParams: angular.ui.IStateProvider;
        userCompanyService: Patersons.UserCompanyService;
        key: string;
    
        static $inject = ['$scope', '$location', '$state', '$stateParams','userCompanyService'];

        constructor($scope, $location, $state, $stateParams,userCompanyService){
            this.$ctrl = this;
            this.scope = $scope;
            this.scope.events = this;
            this.scope.menuOpen = false;
            this.userCompanyService = userCompanyService;

            this.userCompanyService.getUserCompany().then((company) => {
                this.scope.userCompany = company;
                this.initOptions();
            })
            
        }
        private initOptions() {
            const items = [];
            items.push({
                key: "holdings",
                title: "Holdings",
            })
            if(this.scope.userCompany.isDefault){
                items.push({
                    key: "portfolioSnapshot",
                    title: "Snapshot",
                })
                items.push({
                    key: "portfolioHeatmap",
                    title: "Heatmap",
                })
                items.push({
                    key: "marketOrders",
                    title: "Orders",
                })
            }

            items.push({
                key: "ledger",
                title: "Ledger",
            })
            items.push({
                key: "confirmationNotes",
                title: "Contract Notes",
            })
            items.push({
                key: "report",
                title: "Accolade Portfolio Service",
            })
            this.scope.items = items;
        }
        private toggleMenu(){
            this.scope.menuOpen = !this.scope.menuOpen;
        }
    }
}